import React from 'react';
import PropTypes from 'prop-types';

import SelectWithLabelV2 from '../../../../components/composite/FormSets/SelectWithLabelV2/SelectWithLabelV2';
import { setFieldAndValidate } from '../../../../utils/field-utils';
import { userFieldSchemas } from '../../../../utils/validation-utils';

const RoleSelectorControlSet = ({ role, setRole, roleType, setRoleType, availableRoles }) => {
  return (
    <SelectWithLabelV2
      id="role"
      label="Role"
      value={`${roleType}:${role.value}`}
      options={
        [
          { 
            display: 'Choose:', 
            value: '',
            disabled: false,
          },
          ...availableRoles.map(
            (r) => ({
              display: r.label,
              value: `${r.type}:${r.value}`,
              disabled: false,
            }),
          ),
        ]
      }
      errorMsg={role.error}
      onChange={({ target: { value } }) => {
        const [type,roleValue] = value.split(':');
        setFieldAndValidate(role, setRole, roleValue, userFieldSchemas.role);
        setRoleType(type);
      }}
    />
  );
};

RoleSelectorControlSet.propTypes = {
  role: PropTypes.shape({
    value: PropTypes.string.isRequired,
    state: PropTypes.number.isRequired,
    error: PropTypes.string,
  }).isRequired,
  setRole: PropTypes.func.isRequired,
  availableRoles: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  })).isRequired,
};

export default RoleSelectorControlSet;